import identify from '../../analytics/identify';

interface IdentifyLeadArgs {
  userId: number;
}

/**
 * A light wrapper around Segment's identify method.
 * This can be used to identify a lead who has already been created in the system but may or may not have started the signup flow yet.
 */
export function identifyLead({ userId }: IdentifyLeadArgs) {
  identify({ id: userId });
}
